(ns app.front.view.admin.commands.unblock-data-import
  (:require [app.front.ui :as ui]
            [app.front.util :as futil]
            [app.front.view.group.admin.common :as acommon]
            [clojure.string :as str]
            [core.front.event :refer [<sub >evt]]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]
            [reagent.core :as r]))

(rf/reg-event-fx ::unblock-import
  (fn [_ [_ import-session-id]]
    {:comm/command {:command :admin/unblock-import-session
                    :data    (util/mmap import-session-id)
                    :notify  {:success "Data import restored to a state where it can be reprocessed."}}}))

(rf/reg-event-fx ::remove-session
  (fn [_ [_ authority-group-id session-id]]
    {:comm/command {:command :admin/remove-import-session
                    :data    (util/mmap authority-group-id session-id)
                    :notify  {:success "Data import session removed."}}}))

(defn- on-input-change [*ratom]
  (comp (partial reset! *ratom)
        str/trim
        futil/tval))

(defn- is-pos-int? [input]
  (pos-int? (parse-long input)))

(defn- unblock-data-import [tr]
  (r/with-let [*import-session-id (r/atom "")]
    [acommon/section {:title "Unblock data import"}
     [ui/help
      (str "If a data-import has been stuck in the 'Finalizing' or 'Processing file' state for a long time, this command can "
           "be used to set it back to a state where it can be continued. If the import is deleted or settings are edited, "
           "the already-imported data will be deleted, potentially causing missing data! Only use this if "
           "you are sure that the processing has crashed and is just not slow.")]
     [:div.flex.items-end
      [ui/text-input
       {:id          "import-entity-id-unblock"
        :placeholder "1234321567"
        :value       @*import-session-id
        :on-change   (on-input-change *import-session-id)}]
      [:div.ml-4
       [ui/modal-confirmation-button
        (util/mmap {:on-yes-click        (fn [_]
                                           (>evt [::unblock-import (parse-long @*import-session-id)])
                                           (reset! *import-session-id ""))
                    :trigger-button-opts {:size :field}
                    :trigger-button-text "Unblock data import"
                    :disabled?           (not (is-pos-int? @*import-session-id))}
                   tr)
        [:p "Restore the following data import session from finalizing to imported state: "
         [:span.bold @*import-session-id]]]]]]))

(defn- remove-import-session [tr]
  (r/with-let [*import-session-id  (r/atom "")
               *authority-group-id (r/atom "")]
    [acommon/section {:title "Remove import session"}
     [ui/help
      (str "Remove (and clean up) import session in :import-session.state/in-progress"
           " or :import-session.state/removed state. Use wisely as the import may really"
           " be in progress and hence lead to orphan data.")]
     [:div.flex.items-end
      [ui/text-input
       {:id          "authority-group-id"
        :label-text  "Authority group id"
        :placeholder "1234321567"
        :value       @*authority-group-id
        :on-change   (on-input-change *authority-group-id)}]
      [ui/text-input
       {:id          "import-entity-id-remove"
        :label-text  "Import session id"
        :class       "ml-4"
        :placeholder "1234321567"
        :value       @*import-session-id
        :on-change   (on-input-change *import-session-id)}]
      [:div.ml-4
       [ui/modal-confirmation-button
        (util/mmap {:on-yes-click        (fn [_]
                                           (>evt [::remove-session
                                                  (parse-long @*authority-group-id)
                                                  (parse-long @*import-session-id)])
                                           (reset! *authority-group-id "")
                                           (reset! *import-session-id ""))
                    :trigger-button-opts {:size :field}
                    :trigger-button-text "Remove import session"
                    :disabled?           (not (and (is-pos-int? @*authority-group-id)
                                                   (is-pos-int? @*import-session-id)))}
                   tr)
        [:p "Remove the following import session: "
         [:span.bold (str @*authority-group-id " / " @*import-session-id)]]]]]]))

(defn view [match]
  (let [tr (<sub [:tr])]
    [acommon/admin-page (util/mmap {:title "Unblock data import / remove session"} match)
     [unblock-data-import tr]
     [remove-import-session tr]]))

(def route
  {:name :view/admin.commands.unblock-data-import
   :view view})
